import { CleanIcon } from '@hugeicons/react'

interface EmptyAlertProps {
  title: string
  subtitle: string
}

export const EmptyAlert = ({ title, subtitle }: EmptyAlertProps) => {
  return (
    <div className="alert alert-warning flex items-center gap-2 border-0">
      <CleanIcon size={30} className="text-warning shrink-0" />
      <div className="flex flex-col grow">
        <span className="font-semibold text-base text-gray-800">{title}</span>
        <span className="text-gray-700">{subtitle}</span>
      </div>
    </div>
  )
}
